import moment from "moment/moment";
import ErrorIcon from "@mui/icons-material/Error";
import { routeConfigFrontDesk } from "routes/RouteConfig";
import { StringRegex, emailReg } from "./Regex";

export const isAuthUsers = (path) => {
  let isAuth = false;
  const role = localStorage.getItem("role");

  let routeConfig;
  if (role === "3") {
    routeConfig = routeConfigFrontDesk;
  } else {
    routeConfig = routeConfigFrontDesk;
  }
  routeConfig?.forEach((route) => {
    if (route.path === path) {
      isAuth = route.isAuth;
    }
    return isAuth;
  });

  return isAuth;
};

export const errorFieldText = (props) => {
  return (
    <div className="errorMessage">
      <ErrorIcon />
      <span>{props}</span>
    </div>
  );
};

export const handleValidationForm = (data, domainName, formValues, carOption) => {
  let formIsValid = true;
  let errorVal = {};
  const emailRegex = emailReg;
  let keys = Object.keys(data);
  keys.forEach((type, idx) => {
    // Prevent empty spaces at the beginning of the input
    if (typeof data[type] === "string" && data[type].startsWith(" ")) {
      formIsValid = false;
      return (errorVal[type] = errorFieldText(
        "Cannot start with an empty space"
      ));
    }

    switch (type) {
      case "mobileOrEmail":
        //check input validation
        if (type === "mobileOrEmail" && data[type]?.length !== 10) {
          if (emailRegex.test(data[type])) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            errorVal[type] = errorFieldText("Email or Mobile is incorrect");
          }
        } else if (data[type]?.length === 10) {
          if (Number(data[type])) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            errorVal[type] = errorFieldText("Email or Mobile is incorrect");
          }
        } else {
          errorVal[type] = "";
        }
        break;
      case "phoneNumber":
        //check input validtokenation
        if (data[type] === "e") {
          data[type] = 0;
        }
        if (data[type]?.length !== 10) {
          formIsValid = false;
          errorVal[type] = errorFieldText("Mobile number is incorrect");
          const element = document.getElementsByClassName("appLayout");
        } else if (data[type]?.length === 10) {
          if (Number(data[type])) {
          } else {
            formIsValid = false;
            errorVal[type] = errorFieldText("Mobile number is incorrect");
          }
        }
        break;
        case "employeePhoneNumber":
          //check input validtokenation
          if (data[type] === "e") {
            data[type] = 0;
          }

          if(data[type]?.length >= 8 &&  data[type]?.length <= 11){
          errorVal[type] = "";
          formIsValid = true;
          }else {
            formIsValid = false;
            errorVal[type] = errorFieldText("Mobile number is incorrect");
          }
        break;
      case "employeeName":
      case "name": {
        if (StringRegex.test(data[type])) {
          formIsValid = false;
          errorVal[type] = errorFieldText("This field should be only text");
        } else {
          errorVal[type] = "";
        }
        break;
      }
      case "email":
        //check input validation
        if (type === "email" && emailRegex.test(data[type])) {
          errorVal[type] = "";
        } else {
          formIsValid = false;
          errorVal[type] = errorFieldText("Enter a valid email address");
        }
        break;
        case "noOfTravelers": {
            const seater = Number(formValues?.vehicleSeater);
          if(seater === 0 || Number(data[type]) > seater) {
            formIsValid = false;
            errorVal[type] = `Max no. of passengers allowed is ${seater}`;
          }
          else {
            formIsValid = true;
            errorVal[type] = "";
          }
          break;
        }
        case "newEmployeeEmail":
        if(formValues?.travellerType === "newTraveller") {
          if (
            type === "newEmployeeEmail" && emailRegex.test(data[type]) && domainName === data[type].split("@")[1]
          ) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            if(data[type]?.search("@") > 0) {
              errorVal[type] = errorFieldText("Enter a valid domain");
            }
            else {
              errorVal[type] = errorFieldText("Enter a valid email ID");
            }
          }
        }
        break;
        case "companyEmployeeEmail":
          if (
            type === "companyEmployeeEmail" && emailRegex.test(data[type]) && domainName === data[type].split("@")[1]
          ) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            if(data[type]?.search("@") > 0) {
              errorVal[type] = errorFieldText("Enter a valid domain");
            }
            else {
              errorVal[type] = errorFieldText("Enter a valid email ID");
            }
          }
        break;
      default:
    }

    // Check if required is false and length is 0
    if (!data[type] && data[type]?.length === 0) {
      errorVal[type] = "";
    }
  });

  return { formIsValid, errorVal };
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem("token") != null
        ? localStorage.getItem("token")
        : null;
  } catch (error) {
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      return user.data;
    } else {
      return user;
    }
  } catch (error) {
    return error;
  }
};

export const truncateComment = (comment, wordLimit) => {
  if (comment?.length > wordLimit) {
    return comment.slice(0, wordLimit) + "...";
  } else {
    return comment;
  }
};

export const optionsList = (value) => {
  if (value?.AirportTrip) {
    return value?.AirportTrip;
  } else if (value?.B2bRentalTrip) {
    return value?.B2bRentalTrip;
  } else if (value?.OutStationTrip) {
    return value?.OutStationTrip;
  } else if (value?.OutStationTripOneWay) {
    return value?.OutStationTripOneWay;
  }
};

export const getDateFormat = (value, type) => {
  switch (type) {
    case "fromNowFormat":
      return moment(value).fromNow();
    case "time":
      return moment(value).format("HH:mm");
    case "tripTime":
      return moment(value, "DD/MM/YYYY hh:mm a").toISOString();
    case "date":
      return moment(value).format("DD/MM/YYYY");
      case "tenure":
      return moment(value).format("DD MMM YYYY");
    case "weekDay":
      return moment(value).format("ddd DD MMM, YYYY");
    default:
      return moment(value).format("MM/DD/YYYY");
  }
};

export const getDateComparision = (value) => {
  const currentDateObj = new Date();
  const currentYear = currentDateObj.getFullYear();
  const currentMonth = currentDateObj.getMonth() + 1; // Adding 1 as months are zero-based
  const currentDate = currentDateObj.getDate();

  const providedDateObj = new Date(value);

  const providedYear = providedDateObj.getFullYear();
  const providedMonth = providedDateObj.getMonth() + 1; // Adding 1 as months are zero-based
  const providedDate = providedDateObj.getDate();

  if (providedYear > currentYear) {
    return true;
  }  else if(providedYear === currentYear) {
    //Comparing date based on month
   if (providedMonth > currentMonth) {
     return true;
   }
   else if (providedMonth === currentMonth) {
     //Comparing date based on day
     if(providedDate > currentDate) {
       return true;
     }
   }
 }
};

// Function to fix the digit after decimal
export const formatNumber = (value) => {
  if (typeof value === "number" && value % 1 !== 0) {
    return value.toFixed(2);
  }
  return value || 0;
};

// CGST calculation
export const calculateAmount = (baseAmount, percentage) =>
  (baseAmount * percentage) / 100;

// Function for currency format
export const formatCurrency = (amount) => {
  if (!isNaN(amount)) {
    const tempAmount = formatNumber(amount);
    return new Intl.NumberFormat("en-IN").format(tempAmount);
  }
  return amount || 0;
};

export const reservationHeader = (key) => {

  const obj = {
    "bookingCompany": "Booking receive from",
    "travellerDetails": "Enter Traveller Details",
    "dutyAndVehicle": "Select Duty Type & Vehicle Category Details",
    "tripDetails": "Enter Trip Details",
    "tripNote": "Add any Special Instruction",
    "billingType": "Billing Details"
  } 

  return obj[key] || key
  
}
